export default {
  siteUrl: process.env.GATSBY_HOST,
  stripePublicKey: process.env.GATSBY_STRIPE_PUBLIC_KEY || '',
  fellowYouDot: process.env.GATSBY_FELLOW_YOU_DOT,
  fellowApi: `${process.env.GATSBY_FELLOW_YOU_DOT}api/`,  // the trailing slash is included in the environment variable
  branch: process.env.GATSBY_BRANCH,
  gaID: process.env.GATSBY_GA_ID,
  intercomWorkspaceID: process.env.GATSBY_INTERCOM_WORKSPACE_ID,
  showShippingOptionsInCart: process.env.GATSBY_SHOW_SHIPPING_OPTIONS?.toLowerCase() === 'true' ? true : false,
}